import ComponentsFactory from 'foundation/components-factory';
import ModalSpaTriggerComponent from './js/modal-spa-trigger.component';

ComponentsFactory.getInstance().define('modal-spa-trigger', ModalSpaTriggerComponent);
